<template>
  <quizset-form />
</template>

<script>
import QuizsetForm from '@/components/EventQuizsetClosed/Form'

export default {
  components: {
    QuizsetForm
  },

  created: async function () {
    this.$store.commit('eventQuizsetClosed/setEventId', this.$route.params.id)
    await this.$store.dispatch('eventQuizsetClosed/get')
    this.$store.dispatch('eventQuizsetClosed/initForm')
  }
}
</script>
